import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const VoiceArrowIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <path d="M20.3536 12.3536C20.5488 12.1583 20.5488 11.8417 20.3536 11.6464L17.1716 8.46447C16.9763 8.2692 16.6597 8.2692 16.4645 8.46447C16.2692 8.65973 16.2692 8.97631 16.4645 9.17157L19.2929 12L16.4645 14.8284C16.2692 15.0237 16.2692 15.3403 16.4645 15.5355C16.6597 15.7308 16.9763 15.7308 17.1716 15.5355L20.3536 12.3536ZM3 12.5L20 12.5V11.5L3 11.5V12.5Z" fill="var(--COLOR-000533)" stroke="none" />
  </SvgIcon>;
};
